import React, { useEffect, useState } from 'react';
import { fetchTopReviews } from '../../functions/Reviews';

function Testimonials() {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const getReviews = async () => {
      const data = await fetchTopReviews();
      setReviews(data);
    };
    getReviews();
  }, []);

  return (
    <div className="testimonials-container d-flex flex-row gap-3">
      {reviews.length === 0 && (
        <div className="text-white">No testimonials yet.</div>
      )}
      {reviews.map((review, idx) => (
        <div className="testimonial-card flex-fill" key={review._id || idx}>
          <div className="d-flex align-items-center mb-2 w-100">
            <div className="avatar">
              {review.name && (
                <div className="avatar-name">
                  {review.name}
                </div>
              )}
            </div>
            <div className="stars ms-auto">
              {[...Array(5)].map((_, i) =>
                i < (review.rating || 5) ? (
                  <i className="fas fa-star text-warning" key={i}></i>
                ) : (
                  <i className="far fa-star text-warning" key={i}></i>
                )
              )}
            </div>
          </div>
          <p className="text-white" style={{ fontSize: '0.85rem' }}>
            " {review.text || review.comment || ''} "
          </p>
        </div>
      ))}
    </div>
  );
}

export default Testimonials;